import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions, mapMutations } from 'vuex';
import pickBy from 'lodash/pickBy';
import isNil from 'lodash/isNil';
import defer from 'lodash/defer';
import shallowEqualObjects from 'shallow-equal/objects';
import registerStoreModule from '~/helpers/store-helper';
import pageActions from '~/store/modules/pageActions';
import search from '~/store/modules/search';
import { extractCategoryFilterByFromQuery, extractCategorySortByFromQuery, extractCategoryOrderByFromQuery, extractCategoryPreviousPageFromQuery, extractCategoryNextPageFromQuery, extractCategoryQueryFromFilterBy, extractSelectedFilters } from '~/helpers/extract-helper';
import MdmBreadcrumb from '~/components/atoms/Global/MdmBreadcrumb.vue';
import SearchSeo from '~/components/functional/Seo/SearchSeo.vue';
import CategoryTcVars from '~/components/functional/TcVars/CategoryTcVars.vue';
import CategoryLoading from '~/components/templates/Category/CategoryLoading.vue';
import CategoryTemplate from '~/components/templates/Category/CategoryTemplate.vue';
import Empty from '~/components/specific/Blocks/Empty.vue';
export default {
  components: {
    MdmBreadcrumb,
    SearchSeo,
    CategoryTcVars,
    CategoryLoading,
    CategoryTemplate,
    Empty
  },
  httpHeaders: () => ({
    'Cache-Control': 'max-age=0, s-maxage=86400, public'
  }),

  data() {
    return {
      loadingProducts: true,
      loadingNextPage: false,
      loadingPreviousPage: false,
      unwatchSearchQuery: null,
      unwatchNextPage: null,
      unwatchPreviousPage: null
    };
  },

  computed: _objectSpread({}, mapGetters({
    baseURL: 'request/baseURL',
    locale: 'i18n/locale',
    description: 'search/description',
    products: 'search/products',
    productsCount: 'search/productsCount',
    filterBy: 'pageActions/filterBy',
    orderBy: 'pageActions/orderBy',
    sortBy: 'pageActions/sortBy',
    previousPage: 'pageActions/previousPage',
    nextPage: 'pageActions/nextPage'
  }), {
    categoryQuery() {
      return _objectSpread({}, extractCategoryQueryFromFilterBy(this.filterBy), {
        sort: this.sortBy,
        order: this.orderBy
      });
    },

    selectedFilters() {
      return extractSelectedFilters(this.filterBy, this.description.filters);
    },

    currentPath() {
      return "".concat(this.baseURL).concat(this.buildSearchUrl(this.locale, this.description.query));
    },

    breadcrumb() {
      const breadcrumb = this.description.breadcrumb || [];
      return breadcrumb.map(entry => ({
        label: entry.title,
        url: "/".concat(this.locale.market, "/").concat(this.locale.language)
      }));
    },

    pageTitle() {
      var _ref, _ref2;

      const replacement = {
        x: this.productsCount,
        y: (_ref2 = this.description) != null ? _ref2.query : _ref2,
        z: (_ref = this.description) != null ? _ref.suggest_query : _ref
      };
      let tradName = 'searchTitle';

      if (!this.productsCount) {
        tradName = 'searchTitleNoResults';
      } else if (this.description.is_corrected) {
        tradName = 'searchTitleCorrect';
      } else if (this.description.suggest_query) {
        tradName = 'searchTitleSuggest';
      }

      return this.$i18n.tc(tradName, this.productsCount, replacement);
    },

    speedcurveConfig() {
      const luxConfig = {
        innerHTML: 'LUX = window.LUX || {}; LUX.label = "search";'
      };
      return luxConfig;
    }

  }),

  created() {
    registerStoreModule(this.$store, 'search/', search);
    registerStoreModule(this.$store, 'pageActions/', pageActions);

    if (process.client) {
      const {
        params: {
          keyword
        },
        query
      } = this.$route;
      const args = {
        keyword,
        query
      };
      this.resetPagination();
      this.resetFilters();
      this.resetSearch();
      this.setDefaultFilterBy(extractCategoryFilterByFromQuery(query));
      this.setDefaultSortBy(extractCategorySortByFromQuery(query));
      this.setDefaultOrderBy(extractCategoryOrderByFromQuery(query));
      this.setPreviousPage(extractCategoryPreviousPageFromQuery(query));
      this.setNextPage(extractCategoryNextPageFromQuery(query));

      try {
        this.fetchSearch(args).then(() => {
          this.loadingProducts = false;
          this.scrollBackToProduct(localStorage.getItem('currentProduct'));
          localStorage.removeItem('currentProduct');
        });
      } catch (error) {
        if (this.$sentry) {
          this.$sentry.captureException(error);
        }
      }
    }
  },

  mounted() {
    var _this = this;

    return _asyncToGenerator(function* () {
      _this.unwatchSearchQuery = _this.$watch('categoryQuery',
      /*#__PURE__*/
      function () {
        var _ref3 = _asyncToGenerator(function* (oldVal, newVal) {
          if (!shallowEqualObjects(oldVal, newVal)) {
            _this.loadingProducts = true;
            yield _this.handleWatcher(_this.fetchSearch, 1);

            _this.resetPagination();

            _this.scrollBackToCategoryTitle();

            _this.loadingProducts = false;
          }
        });

        return function (_x, _x2) {
          return _ref3.apply(this, arguments);
        };
      }());
      _this.unwatchNextPage = _this.$watch('nextPage',
      /*#__PURE__*/
      _asyncToGenerator(function* () {
        const predicate = _this.nextPage === 1 && _this.previousPage === 1;

        if (!predicate) {
          _this.loadingNextPage = true;
          yield _this.handleWatcher(_this.appendProducts, _this.nextPage);
          _this.loadingNextPage = false;
        }
      }));
      _this.unwatchPreviousPage = _this.$watch('previousPage',
      /*#__PURE__*/
      _asyncToGenerator(function* () {
        const predicate = _this.nextPage === 1 && _this.previousPage === 1;

        if (!predicate) {
          _this.loadingPreviousPage = true;
          yield _this.handleWatcher(_this.prependProducts, _this.previousPage);
          _this.loadingPreviousPage = false;
        }
      }));
    })();
  },

  beforeDestroy() {
    this.unwatchSearchQuery();
    this.unwatchNextPage();
    this.unwatchPreviousPage();
  },

  methods: _objectSpread({}, mapMutations({
    setDefaultFilterBy: 'pageActions/SET_DEFAULT_FILTERBY',
    setDefaultSortBy: 'pageActions/SET_DEFAULT_SORTBY',
    setDefaultOrderBy: 'pageActions/SET_DEFAULT_ORDERBY',
    setPreviousPage: 'pageActions/SET_PREVIOUS_PAGE',
    setNextPage: 'pageActions/SET_NEXT_PAGE',
    resetPagination: 'pageActions/RESET_PAGINATION',
    resetFilters: 'pageActions/RESET_FILTERS',
    resetSearch: 'search/RESET_SEARCH'
  }), mapActions({
    fetchSearch: 'search/fetchContent',
    appendProducts: 'search/appendProducts',
    prependProducts: 'search/prependProducts'
  }), {
    handleWatcher(handler, page) {
      var _this2 = this;

      return _asyncToGenerator(function* () {
        const {
          params: {
            keyword
          }
        } = _this2.$route;

        const query = _objectSpread({}, _this2.categoryQuery, {
          page
        });

        try {
          yield handler({
            query,
            keyword
          });

          _this2.$router.push({
            query: pickBy(query, e => !isNil(e))
          });

          _this2.$root.$emit('reset-tcvars');
        } catch (err) {
          if (_this2.$sentry) _this2.$sentry.captureException(err);
        }
      })();
    },

    scrollBackToCategoryTitle() {
      const title = document.getElementById('category');

      if (title) {
        window.scrollTo({
          top: title.offsetTop
        });
      }
    },

    scrollBackToProduct(arg) {
      if (arg) {
        const currentProduct = JSON.parse(arg);
        defer(() => {
          const product = document.getElementById(currentProduct);

          if (product) {
            window.scrollTo({
              top: product.offsetTop
            });
          }
        });
      }
    }

  }),

  head() {
    return {
      script: [this.speedcurveConfig]
    };
  }

};